import type { Locale } from "date-fns";
import { de, enGB, es, fr } from "date-fns/locale";

const DATE_FNS_LOCALES: Record<string, Locale> = {
  en: enGB,
  de,
  es,
  fr,
};

export function getDateFnsLocale(language: string): Locale {
  const languageCode = language.split("-")[0];
  return DATE_FNS_LOCALES[languageCode] ?? enGB;
}
